module.exports = __webpack_public_path__ + "static/media/close.865c2997.svg";